const ButtonIcon = require('../elements/buttonicon.js')
const PanelElement = require('../elements/panel.js')
const html = require('choo/html')
module.exports = function GlitchDropAreas (state, emit) {
  const dropToAll = ButtonIcon({
    icon: 'expand',
    type: 'tight',
    size: 'large',
    id: "drop-to-all-button",
    noIconBackground: true,
    onMouseUp: () => emit('drop-to-all')
  })
  const trash = ButtonIcon({
    icon: 'trash',
    type: 'tight',
    size: 'large',
    id: "drop-to-trash-button",
    noIconBackground: true,
    onMouseUp: () => emit('drop-to-trash')
  })

  const dropZone = html`
  <div class="glitch-drop-areas-wrapper">
    ${dropToAll}
    ${trash}
  </div>`
  return PanelElement({
    color: 'purple',
    size: 'small',
    noPadding: false,
    children: dropZone
  })
}
